const slashesOnTheEnd = /\/+$/g;

export default function processApiUrl(apiUrl) {
  if (!apiUrl.match(slashesOnTheEnd)) {
    return apiUrl;
  }

  return apiUrl.replace(slashesOnTheEnd, '');
}
